import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchTypologies = createAction('typologies/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedTypologies = createAction(
  'typologies/fetched',
  (data?: State['typologies']['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const fetchConflictTypes = createAction('conflict-types/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedConflictTypes = createAction(
  'conflict-types/fetched',
  (data?: State['conflictTypes']['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchedTypologies,
  fetchTypologies,
  fetchConflictTypes,
  fetchedConflictTypes,
};
